import InternalError, { IBaseInternalErrorParamsWithOrigin } from './InternalError';
import { IBaseSosErrorParams } from './SosError';

export interface IInternalStreamErrorParams extends IBaseSosErrorParams {
	kind: 'internalStreamError';
}

export interface IInternalStreamErrorParamsWithOrigin extends IBaseInternalErrorParamsWithOrigin {
	kind: 'internalStreamErrorWithOrigin';
}

export default class InternalOfflineCacheError extends InternalError {
	constructor(parameters: IInternalStreamErrorParams | IInternalStreamErrorParamsWithOrigin) {
		if (parameters.kind === 'internalStreamError') {
			super({
				...parameters,
				kind: 'internalError',
			});
		} else {
			super({
				...parameters,
				kind: 'internalErrorWithOrigin',
			});
		}
		this.name = 'InternalStreamError';
	}
}
